// extracted by mini-css-extract-plugin
module.exports = {"BookingPolicy":"styles_BookingPolicy__3fUp4","BookingPolicy-content":"styles_BookingPolicy-content__2ZdUx","BookingPolicy-wrapper":"styles_BookingPolicy-wrapper__1Nqz7"};